module.exports = __webpack_public_path__ + "static/mobile-interface-a704fbb798b247411b8ef1490d038a3b.jpg";